import { useEffect, useState } from 'react';
import { BannerData } from '@/types';
import CarouselV2 from '@/components/shared/carouselv2/carouselv2.component';
import Image from 'next/image';

interface bannerObject {
    original: string;
    thumbnail: string;
    outsideLink: string;
    id: string;
}
const BannerImage = ({
    banner,
    index,
    width,
    height,
    preLoad,
}: {
    banner: bannerObject;
    index: number;
    width: number;
    height: number;
    preLoad: boolean;
}) => {
    return (
        <Image
            key={`${banner.id}`}
            src={banner.original}
            alt={`retail banner ${index}`}
            width={width}
            height={height}
            quality={58}
            loading={preLoad ? 'eager' : 'lazy'}
            priority={preLoad}
            fetchPriority={preLoad ? 'high' : 'low'}
            className="aspect-[358/179] lg:aspect-[2039/320] w-full h-full max-h-full object-cover rounded-xl"
        />
    );
};

export default function RetailBanners({
    bannersData = [],
    width,
    height,
    isDesktop,
    isRtl,
    showArrows,
    autoPlay,
}: {
    bannersData: BannerData[];
    width: number;
    height: number;
    isDesktop: boolean;
    isRtl: boolean;
    showArrows: boolean;
    autoPlay: boolean;
}) {
    const handleIncomingData = (bannersData: BannerData[]): bannerObject[] => {
        let finalKey = '';
        if (isRtl) {
            finalKey += 'ar';
        } else {
            finalKey += 'en';
        }
        if (isDesktop) {
            finalKey += 'Desktop';
        } else {
            finalKey += 'Mobile';
        }
        finalKey += 'Url';
        return bannersData.map((item: any) => {
            return {
                original: item[finalKey] as string,
                thumbnail: item[finalKey] as string,
                outsideLink: item.destinationUrl as string,
                id: item.id,
            };
        });
    };
    const [displayBanners, setDisplayBanners] = useState<bannerObject[]>(
        handleIncomingData(bannersData)
    );
    useEffect(() => {
        if (bannersData.length > 0) {
            setDisplayBanners(handleIncomingData(bannersData));
        }
    }, [bannersData]);
    return (
        <>
            <CarouselV2
                showArrows={showArrows}
                showDots={true}
                autoPlay={autoPlay}
                frameDuration={5000}
            >
                {displayBanners.map((banner, index) =>
                    banner.outsideLink ? (
                        <a
                            key={`banner-cont-${banner.id}`}
                            href={`${banner.outsideLink}`}
                            target="_blank"
                            rel="noreferrer"
                        >
                            <BannerImage
                                banner={banner}
                                index={index}
                                width={width}
                                height={height}
                                preLoad={isDesktop && index === 0}
                            />
                        </a>
                    ) : (
                        <BannerImage
                            key={`banner-cont-${banner.id}`}
                            width={width}
                            height={height}
                            banner={banner}
                            index={index}
                            preLoad={isDesktop && index === 0}
                        />
                    )
                )}
            </CarouselV2>
        </>
    );
}
